import React 			from 'react'
import renderHTML 		from 'react-render-html'

import InlineImage 		from '../../../inline-image'

import {
	formatImageForARYImage
} from '../../../../lib/_helpers'

import Section 			from '../section'

export default (props) => {
	const {
		image
	} = props

	const _image = formatImageForARYImage(image)

	return <Section
		type="image"
		colWidth={ _image && (_image.height > _image.width || _image.aspectRatio < 1) ? 5  : null }
		>
		{ _image ? <InlineImage
			image={ _image } /> : null }
	</Section>
}